export const ADMIN_ROLES = ["system_admin", "super_admin"];
